import React, { Component } from "react";

function AddUnit(e) {
  if (e.unit) {
    return e.unit;
  }
  return null;
}

function AddCurrency(e) {
  if (e.currency) {
    return e.currency;
  }
  return null;
}

function DisplayTitle(e) {
  if (e.title) {
    return <div className="text-center">{e.title}</div>;
  }
  return null;
}

function DisplayImage(e) {
  if (e.image) {
    return (
      <div className="icon text-center">
        <img src={e.image} alt={e.title} />
      </div>
    );
  } else {
    return null;
  }
}

function ListItem(e) {
  let title = e.title;
  let unit = e.unit;
  let currency = e.currency;
  //let desc = e.desc;
  let value = e.value;
  let image = e.image;

  return (
    <React.Fragment>
      <div className="detail-block">
        <div className="wrapper">
          <DisplayImage image={image} />
          <DisplayTitle title={title} />
        </div>

        <div className="detail-saving text-center">
          Savings Up To&nbsp;
          <span>
            <AddCurrency currency={currency} />
            {value}
          </span>{" "}
          <AddUnit unit={unit} />
        </div>
      </div>
    </React.Fragment>
  );
}

class DetailBlock extends Component {
  constructor(props) {
    super();
  }

  render() {
    let title = this.props.title;
    let value = this.props.propValue;
    let unit = this.props.unit;
    let currency = this.props.currency;
    let desc = this.props.desc;
    let image = this.props.image;

    return (
      <React.Fragment>
        <ListItem
          title={title}
          desc={desc}
          value={value}
          currency={currency}
          unit={unit}
          image={image}
        />
      </React.Fragment>
    );
  }
}

export default DetailBlock;
